export default "__VITE_ASSET__BF15YngO__"